const GASTRONOMIC_PROPOSAL_CONSTANTS = {
    GASTROBAR_URL: "https://www.iberia.com/wcs/documentos/experiencia_iberia/IBERIA_IN23_GASTROBAR_LITE_EN.PDF",
    GASTROBAR_URL_ES: "https://www.iberia.com/wcs/documentos/experiencia_iberia/IBERIA_IN23_GASTROBAR_LITE_ES.PDF",
    AIRLINES_AVAILABLES: ['IB', 'I2', 'YW', 'EB'],
    DATALAYER_INTERACTION_TYPE: {
        INTERACTION: 'INTERACTION',
        IMPRESSION: 'IMPRESSION'
    },
};
const DIGITAL_MENU_CONSTANTS = {
    MAX_DATES_AVAILABLE: 35,
    DEFAULT_IMG: '/iberia-web-content/imagenes/digital_menu/defaultImages/',
    ALERGENS_ICONS_URL: "/iberia-web-content/imagenes/digital_menu/alergenos/bycode/",
    ALLERGENS_DATA: [
        { code: 'GLU', name: 'MMB_GASTRONOMIC_PROPOSAL_DIGITAL_MENU_ALLERGEN_GLUTEN', image: 'GLU.png' },
        { code: 'MUS', name: 'MMB_GASTRONOMIC_PROPOSAL_DIGITAL_MENU_ALLERGEN_MUSTART', image: 'MUS.png' },
        { code: 'SES', name: 'MMB_GASTRONOMIC_PROPOSAL_DIGITAL_MENU_ALLERGEN_SESAME', image: 'SES.png' },
        { code: 'CEL', name: 'MMB_GASTRONOMIC_PROPOSAL_DIGITAL_MENU_ALLERGEN_CELERY', image: 'CEL.png' },
        { code: 'LUP', name: 'MMB_GASTRONOMIC_PROPOSAL_DIGITAL_MENU_ALLERGEN_LUPINS', image: 'LUP.png' },
        { code: 'PEA', name: 'MMB_GASTRONOMIC_PROPOSAL_DIGITAL_MENU_ALLERGEN_PEANUTS', image: 'PEA.png' },
        { code: 'MOL', name: 'MMB_GASTRONOMIC_PROPOSAL_DIGITAL_MENU_ALLERGEN_MOLLUSCS', image: 'MOL.png' },
        { code: 'MLK', name: 'MMB_GASTRONOMIC_PROPOSAL_DIGITAL_MENU_ALLERGEN_MILK', image: 'MLK.png' },
        { code: 'FSH', name: 'MMB_GASTRONOMIC_PROPOSAL_DIGITAL_MENU_ALLERGEN_FISH', image: 'FSH.png' },
        { code: 'SOY', name: 'MMB_GASTRONOMIC_PROPOSAL_DIGITAL_MENU_ALLERGEN_SOYA', image: 'SOY.png' },
        { code: 'EGG', name: 'MMB_GASTRONOMIC_PROPOSAL_DIGITAL_MENU_ALLERGEN_EGGS', image: 'EGG.png' },
        { code: 'CRU', name: 'MMB_GASTRONOMIC_PROPOSAL_DIGITAL_MENU_ALLERGEN_CRUSTACEANS', image: 'CRU.png' },
        { code: 'NUT', name: 'MMB_GASTRONOMIC_PROPOSAL_DIGITAL_MENU_ALLERGEN_NUTS', image: 'NUT.png' },
        { code: 'SPH', name: 'MMB_GASTRONOMIC_PROPOSAL_DIGITAL_MENU_ALLERGEN_SULPHITES', image: 'SPH.png' }
    ],


}
export { GASTRONOMIC_PROPOSAL_CONSTANTS, DIGITAL_MENU_CONSTANTS };
